import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import StyledImg from '~/client/shared/images/styles/StyledImg';

const ProviderGameImage = styled(StyledImg)`
  border-radius: ${rem(12)};
  transform: rotate(-5deg);
  margin: ${rem(4)};
`;

export default ProviderGameImage;
